import { Route, Routes } from 'react-router-dom'
import { TableWSLItems } from './Table/table';


export const BrowserWSLItems = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableWSLItems />} />
        </Routes>
    );
}
